import React from "react";
import { Helmet } from "react-helmet";
import Header from "../Components/Header";
import Nav from "../Components/Nav";

const styles = {
  page: { fontFamily: "inherit" },
  mainContent: { padding: "1rem" },
  pageHeader: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "2rem 0"
  },
  title: {
    fontWeight: 600,
    fontSize: "18px",
    marginBottom: 0
  },
  breadcrumb: {
    marginBottom: 0
  },
  card: {
    overflow: "hidden",
    boxShadow: "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)"
  },
  cardBody: {
    padding: 0
  },
  termsHeading: {
    padding: "1rem",
    display: "flex",
    alignItems: "center",
    color: "white",
    backgroundColor: "#0d6efd",
    fontSize: "1.25rem",
    fontWeight: 600,
    marginBottom: 0
  },
  avatar: {
    marginRight: "1rem",
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    overflow: "hidden"
  },
  termsConditions: {
    padding: "1.5rem",
    color: "#6c757d"
  },
  sectionTitle: {
    fontWeight: 600,
    paddingBottom: "1rem",
    color: "#0d6efd",
    opacity: 0.7
  },
  sectionText: {
    opacity: 0.7,
    marginBottom: "1rem"
  },
  footer: {
    marginTop: "auto",
    padding: "1rem",
    backgroundColor: "#ffffff",
    textAlign: "center"
  },
  footerText: {
    color: "#6c757d"
  },
  footerLink: {
    color: "#000000",
    fontWeight: 600,
    textDecoration: "none"
  },
  flag: {
    marginTop: "0.5rem"
  },
  scrollToTop: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    cursor: "pointer"
  },
  checkboxLabel: {
    color: "#6c757d"
  },
  btnList: {
    display: "flex",
    gap: "0.5rem",
    marginTop: "1rem"
  }
};

function Agreement() {
  return (
    <div style={styles.page}>
      <Helmet>
        <script src="forthfunded/popper.min.js" />
        <script src="forthfunded/bootstrap.bundle.min.js" />
        <script src="forthfunded/defaultmenu.min.js" />
        <script src="forthfunded/waves.min.js" />
        <script src="forthfunded/sticky.js" />
        <script src="forthfunded/simplebar.min.js" />
        <script src="forthfunded/simplebar.js" />
        <script src="forthfunded/pickr.es5.min.js" />
        <script src="forthfunded/apexcharts.min.js" />
        <script src="forthfunded/crypto-dashboard.js" />
        <script src="forthfunded/custom-switcher.min.js" />
        <script src="forthfunded/custom.js" />
      </Helmet>


      <Header />
      <Nav />

      <div style={styles.mainContent}>
        <div style={styles.pageHeader}>
          <h1 style={styles.title}>Terms of Service</h1>
          <nav>
            <ol style={styles.breadcrumb}>
              <li><a href="/dashboards">Dashboard</a></li>
              <li>Terms</li>
            </ol>
          </nav>
        </div>

        <div>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div style={{ maxWidth: "900px", width: "100%" }}>
              <div style={styles.card}>
                <div style={styles.cardBody}>
                  <div style={styles.termsHeading}>
                    <span style={styles.avatar}>
                      <img
                        src="../assets/images/media/media-67.png"
                        alt="terms"
                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                      />
                    </span>
                    Terms Of Service
                  </div>

                  <div style={styles.termsConditions}>
                    <div style={{ marginBottom: "2rem" }}>
                      <p style={styles.sectionText}>
                        <strong style={{ color: "#0d6efd", opacity: 0.8 }}>
                          Carefully read through the Agreement.
                        </strong>
                      </p>
                      <p style={styles.sectionText}>
                        This Agreement sets out the specific terms that will apply to you when using the buy shares functionality on FarYieldFi Investment platform...
                      </p>
                    </div>

                    <h6 style={styles.sectionTitle}>Introduction</h6>
                    <div style={{ marginBottom: "1.5rem" }}>
                      <p style={styles.sectionText}>
                        1.1 - These terms and conditions (the "Agreement") govern the purchase of any investment plan ("Securities") from FarYieldFi Investment (the "Company") by the purchaser (the "Buyer").
                      </p>
                    </div>

                    <div style={{ marginBottom: "1.5rem" }}>
                      <p style={{ fontWeight: 600, color: "#6c757d", marginBottom: "0.5rem", fontSize: "14px" }}>
                        Offer and Acceptance
                      </p>
                      <p style={styles.sectionText}>
                        2.1 - By purchasing Securities from the Company, the Buyer agrees to be bound by these terms.
                      </p>
                    </div>

                    <div style={{ marginBottom: "1.5rem" }}>
                      <p style={{ fontWeight: 600, color: "#6c757d", marginBottom: "0.5rem", fontSize: "14px" }}>
                        Purchase Price and Payment
                      </p>
                      <p style={styles.sectionText}>
                        3.1 - The purchase price will be displayed...
                      </p>
                      <p style={styles.sectionText}>
                        3.2 - Payment should be made to the generated accounts or wallets...
                      </p>
                    </div>

                    <div style={{ marginBottom: "1.5rem" }}>
                      <p style={{ fontWeight: 600, color: "#6c757d", marginBottom: "0.5rem", fontSize: "14px" }}>
                        Delivery of Securities
                      </p>
                      <p style={styles.sectionText}>
                        4.1 - The Company agrees to deliver the Securities...
                      </p>
                    </div>

                    <div style={{ marginBottom: "1.5rem" }}>
                      <p style={{ fontWeight: 600, color: "#6c757d", marginBottom: "0.5rem", fontSize: "14px" }}>
                        Representations and Warranties
                      </p>
                      <p style={styles.sectionText}>5.1 - The Company warrants it has the authority...</p>
                      <p style={styles.sectionText}>5.2 - The Buyer warrants it has the authority...</p>
                    </div>

                    <div>
                      <p style={{ fontWeight: 600, color: "#6c757d", marginBottom: "0.5rem", fontSize: "14px" }}>
                        Transfer Restrictions
                      </p>
                      <p style={styles.sectionText}>
                        6.1 - The Buyer acknowledges the Securities may be subject to restrictions...
                      </p>
                    </div>
                  </div>
                </div>

                <div style={{
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: "1rem",
                  boxShadow: "0px -2px 10px rgba(0, 0, 0, 0.1)"
                }}>
                  <div>
                    <input type="checkbox" id="privacy-policy" defaultChecked required />
                    <label htmlFor="privacy-policy" style={styles.checkboxLabel}> I agree with the </label>
                    <a href="../privacy" style={styles.checkboxLabel}><u>Privacy Policy</u></a>
                  </div>
                  <div style={styles.btnList}>
                    <a href="/dashboards" style={{ padding: "0.5rem 1rem", border: "1px solid red", color: "red", borderRadius: "5px", textDecoration: "none" }}>I DECLINE</a>
                    <a href="/invest" style={{ padding: "0.5rem 1rem", backgroundColor: "green", color: "white", borderRadius: "5px", textDecoration: "none" }}>I ACCEPT</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer style={styles.footer}>
        <div>
          <span style={styles.footerText}>
            Copyright © 2025{" "}
            <a href="javascript:void(0);" style={styles.footerLink}>FarYieldFi</a>.
            All Rights Reserved
          </span>
          <div style={styles.flag}>
            <center>
              <img src="../flag.png" alt="flag" width={160} />
              <div id="google_translate_element" />
            </center>
          </div>
        </div>
      </footer>

      <div style={styles.scrollToTop}>
        <span><i className="ri-arrow-up-s-fill fs-20" /></span>
      </div>

      <style
        dangerouslySetInnerHTML={{
          __html: `
            body { top: 0px !important; }
            body > .skiptranslate { display: none; }
            .goog-logo-link, .goog-te-gadget { display: none !important; }
            .goog-te-banner-frame.skiptranslate,
            .goog-tooltip.skiptranslate,
            .activity-root,
            .status-message,
            .started-activity-container { display: none !important; }
            #google_translate_element, #google_translate_element a {
              color: transparent;
              display: none;
            }
            .icon-bar {
              position: relative;
              background-color: white;
              color: black;
              text-align: center;
              width: 100%;
            }
          `
        }}
      />
    </div>
  );
}

export default Agreement;
